"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get SignatureRequestModel () {
        return SignatureRequestModel;
    },
    get SignatureRequestTemplateModel () {
        return SignatureRequestTemplateModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const SignatureRequestModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    audit_trail: _zod.z.array(_zod.z.object({})).optional(),
    cached_pages: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).optional(),
    company: _zod.z.instanceof(_bson.ObjectId),
    completed: _zod.z.boolean(),
    completed_date: _zod.z.date().optional(),
    completed_document_id: _zod.z.instanceof(_bson.ObjectId).optional(),
    completion_date: _zod.z.date().optional(),
    document_id: _zod.z.instanceof(_bson.ObjectId),
    name: _zod.z.string(),
    next_signer_id: _zod.z.instanceof(_bson.ObjectId).optional(),
    pending_cached_pages: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).optional(),
    signers: _zod.z.array(_zod.z.object({}))
});
const SignatureRequestTemplateModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    base_id: _zod.z.instanceof(_bson.ObjectId),
    company: _zod.z.instanceof(_bson.ObjectId),
    completed: _zod.z.boolean().optional(),
    completion_date: _zod.z.date().optional(),
    document_id: _zod.z.instanceof(_bson.ObjectId),
    name: _zod.z.string(),
    signers: _zod.z.array(_zod.z.object({}))
});
